export default __webpack_public_path__ + "static/media/asTemplate.2a58d0b9.csv";